// extracted by mini-css-extract-plugin
module.exports = {"content":"Permissions_content__2tcGX","subtitle":"Permissions_subtitle__3EiIc","firstGroup":"Permissions_firstGroup__3FUi5","bottomBorderDiv":"Permissions_bottomBorderDiv__2MNUM"};